<template>
  <nav class="mobile-bottom-nav">
    <NuxtLink to="/" class="mobile-bottom-nav-item" exact-active-class="active">
      <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
        <rect y="3" width="18" height="1.5" fill="currentColor" />
        <rect y="8" width="18" height="1.5" fill="currentColor" />
        <rect y="13" width="18" height="1.5" fill="currentColor" />
      </svg>
      Liste
    </NuxtLink>
    <NuxtLink
      to="/calendar"
      class="mobile-bottom-nav-item"
      :class="{ active: isCalActive }"
    >
      <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
        <rect
          x="1"
          y="3"
          width="16"
          height="14"
          rx="1.5"
          stroke="currentColor"
          stroke-width="1.5"
        />
        <line
          x1="1"
          y1="7"
          x2="17"
          y2="7"
          stroke="currentColor"
          stroke-width="1.5"
        />
        <line
          x1="5"
          y1="1"
          x2="5"
          y2="5"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linecap="round"
        />
        <line
          x1="13"
          y1="1"
          x2="13"
          y2="5"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linecap="round"
        />
        <rect x="4" y="10" width="2" height="2" rx="0.5" fill="currentColor" />
        <rect x="8" y="10" width="2" height="2" rx="0.5" fill="currentColor" />
        <rect x="12" y="10" width="2" height="2" rx="0.5" fill="currentColor" />
      </svg>
      Cal.
    </NuxtLink>
    <NuxtLink to="/map" class="mobile-bottom-nav-item" active-class="active">
      <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
        <circle
          cx="9"
          cy="7.5"
          r="6"
          stroke="currentColor"
          stroke-width="1.5"
        />
        <circle cx="9" cy="7.5" r="2" fill="currentColor" />
        <line
          x1="9"
          y1="13.5"
          x2="9"
          y2="17"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linecap="round"
        />
      </svg>
      Carte
    </NuxtLink>
    <NuxtLink
      to="/suggest-event"
      class="mobile-bottom-nav-item"
      active-class="active"
    >
      <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
        <line
          x1="9"
          y1="3"
          x2="9"
          y2="15"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linecap="round"
        />
        <line
          x1="3"
          y1="9"
          x2="15"
          y2="9"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linecap="round"
        />
      </svg>
      Suggérer
    </NuxtLink>
    <NuxtLink
      v-if="user"
      to="/admin"
      class="mobile-bottom-nav-item mobile-bottom-nav-admin"
      active-class="active"
    >
      <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
        <circle cx="9" cy="6" r="3" stroke="currentColor" stroke-width="1.5" />
        <path
          d="M2 16c0-3.314 3.134-6 7-6s7 2.686 7 6"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linecap="round"
        />
      </svg>
      Admin
    </NuxtLink>
    <NuxtLink
      v-if="!user"
      to="/login"
      class="mobile-bottom-nav-item"
      active-class="active"
    >
      <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
        <circle cx="9" cy="6" r="3" stroke="currentColor" stroke-width="1.5" />
        <path
          d="M2 16c0-3.314 3.134-6 7-6s7 2.686 7 6"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linecap="round"
        />
      </svg>
      Login
    </NuxtLink>
  </nav>
</template>

<script setup lang="ts">
const user = useSupabaseUser();
const route = useRoute();
const isCalActive = computed(
  () => route.path === '/calendar' && !route.query.saved,
);
</script>
